// extracted by mini-css-extract-plugin
module.exports = {"vWhite1":"#f2f2fa","select":"ReportForm_select__1jJtK"};